module.exports = __webpack_public_path__ + "toBride1-we-w-n.d164c36f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-w-n.jpg
// module id = X+cN
// module chunks = 0